﻿import { IBinder, IBehaviorBinding, ICellBinding } from "./ibinder"
import Utility from "../utility"

export class AutoGrowBinder implements IBinder {
  public getElements(root: JQuery): JQuery {
    return root.find("[data-et-auto-grow='true']");
  }

  public getBinding(element: JQuery): IBehaviorBinding {
    return {
      bindingName: "event",
      bindTo: "{focus : $parent.autoGrow}",
      createEmptyValue: () => null,
      behavior: {
        name: "autoGrow",
        build: data => (item, event) => {
          var isLastRow = $(event.currentTarget).parents("tr").is(":last-child");
          if (!isLastRow)
            return true;
          var lastItem = data.Rows()[data.Rows().length - 1];
          if (Utility.isBlankItem(lastItem))
            return true;

          Utility.addRow(data, 1, false);
          return true;
        }
      }
    }
  }
}